(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zentus-footer"]) return;
  try {
    
  class ZentusCookiePreferences extends HTMLElement {
    #controller;

    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      this.hidden = true;
      this.querySelector('button')?.addEventListener('click', this.#showPreferences, { signal });
      document.addEventListener('load', this.#handleResourceLoad, { capture: true, signal });
      window.addEventListener('load', this.#checkReady, { once: true, signal });
      this.#checkReady();
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    #handleResourceLoad = (event) => {
      if (event.target instanceof HTMLScriptElement) this.#checkReady();
    };

    #checkReady = () => {
      if (typeof window.privacyBanner?.showPreferences !== 'function') return;
      this.hidden = false;
      document.removeEventListener('load', this.#handleResourceLoad, true);
      window.removeEventListener('load', this.#checkReady);
    };

    #showPreferences = async () => {
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      if (!button || !status || button.disabled) return;
      status.textContent = '';
      button.disabled = true;
      try {
        await window.privacyBanner.showPreferences();
      } catch {
        status.textContent = this.dataset.errorMessage;
      } finally {
        button.disabled = false;
      }
    };
  }

  if (!customElements.get('zentus-cookie-preferences')) {
    customElements.define('zentus-cookie-preferences', ZentusCookiePreferences);
  }

  } catch(e) { console.error(e); }
})();
})();
